import { Component, EventEmitter, Output } from '@angular/core'

import { PaymentBatchStateService } from '@modules/private/payment/data/services/view/payment-batch-state.service'

/**
 * Paso 3 · El informe del alta.
 *
 * Los pagos ya existen: aquí solo se rinde cuentas de lo que se creó, qué no se creó y por qué, y se
 * da la dirección con la que se recupera el lote.
 *
 * **Ya no pregunta nada.** Tenía delante una pantalla de confirmación que repetía en forma de lista
 * las mismas cuatro cifras de la revisión para pedir una casilla; el alta y su confirmación se
 * mudaron al final de la revisión, junto a las cifras que confirman. Este paso se quedó con lo único
 * que solo él podía dar: el resultado.
 */
@Component({
	selector: 'app-step3-registro',
	templateUrl: './step3-registro.component.html',
	styleUrls: ['./step3-registro.component.scss'],
})
export class Step3RegistroComponent {
	@Output() onDone = new EventEmitter<void>()
	@Output() onExit = new EventEmitter<void>()

	constructor(public readonly state: PaymentBatchStateService) {}

	/**
	 * Con «solo dar de alta» el asistente termina aquí; con el modo completo, sigue a los destinos.
	 *
	 * El botón dice lo que va a pasar y no «Siguiente»: en el primer caso lo que sigue es salir.
	 */
	continuar(): void {
		if (this.state.mode === 'SOLO_ALTA') {
			this.onExit.emit()
			return
		}

		this.onDone.emit()
	}
}
